import { Injectable, computed, inject, signal } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable, tap } from 'rxjs';
import { AssignWorkerRole, WorkerRolActions } from '../models';
import { GeneralResponse } from '@core/models/general-response.model';
import { Cookies } from 'typescript-cookie';

@Injectable({
  providedIn: 'root',
})
export class WorkerRoleService {
  private _actions = signal<WorkerRolActions[]>([]);
  public actions = computed(() => this._actions());

  private apiService = inject(ApiService);

  storeRoleAssigment(idWorker: number, idNewRole: number) {
    return this.apiService.store(
      `workerRoleActions?workerid=${idWorker}&roleid=${idNewRole}&createdBy=test`,
      undefined
    );
  }

  deleteRoleAsssignment(id: number) {
    return this.apiService.update(`workerRoleActions/${id}`, undefined, 0);
  }

  getRoleNotAssigned(idWorker: number): Observable<AssignWorkerRole> {
    return this.apiService.getAll(
      `workerRoleActions/notAssigned/worker?workerId=${idWorker}`
    );
  }

  getRoleAssigned(idWorker: number): Observable<AssignWorkerRole> {
    return this.apiService.getAll(
      `workerRoleActions/assigned?workerId=${idWorker}`
    );
  }

  updateRoleAssignment(data: AssignWorkerRole, id: number) {
    return this.apiService.update('', data, id);
  }

  getRolActions(): Observable<GeneralResponse<WorkerRolActions[]>> {
    const workerId = Cookies.get('workerId');
    return this.apiService
      .get<WorkerRolActions[]>(`workerRoleActions?workerid=${workerId}`)
      .pipe(
        tap(({ reply }) => {
          this._actions.set(reply);
        })
      );
  }
}
